module.exports = __webpack_public_path__ + "img/screens-laptop-3.2f4a1891.png";